module.exports = __webpack_public_path__ + "img/manticoresearch.15ded83e.svg";